import React from 'react';
import util from "../../util/tools";
import './index.css';
import Header from "../common/Header";

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            bookId: "",
            contentId: 1,
            page: 1,
            totalNum: '',
            curTitle: "目录",
            totalPage: 1,
            data: [],
            order: 'order ASC',
        };
    }

    componentDidMount() {
        let bookId = this.props.match.params.bookId
        this.setState({
            bookId: bookId
        },()=>{
            this.getLastChapter()
            this.getData()
        });
    }

    getData() {
        util.ajax({
            url: "/zh/chapter/chapterList",
            isUser: true,
            isWechatId: true,
            data: {
                'book_id': this.state.bookId,
                'page': this.state.page,
                'order_by': this.state.order,
                'num': 100,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data.chapterList;
                    let totalNum = res.result.total_num;
                    let totalPage = res.result.total_page;
                    this.setState({
                        data: json,
                        totalPage,
                        totalNum
                    })
                }
            }
        });
    }
    getLastChapter(){
        util.ajax({
            url: "/zh/chapter/lastReadChapter",
            isUser: true,
            data: {
                'book_id': this.state.bookId,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    let contentId = 1;
                    if(data.length>0){
                        contentId = data[0].content_id
                    }
                    this.setState({
                        contentId: contentId
                    });
                }
            }
        });
    }

    changePage(type) {
        let page = this.state.page - 1;
        if(page <= 1){
            page = 1;
        }
        if (type == 'next') {
            page = this.state.page + 1
            if (page >= this.state.totalPage) {
                page = this.state.totalPage;
            }
        }
        if(page == this.state.page){
            return false;
        }
        this.setState({
            page: page,
        },()=>{
            this.getData()
        });
    }

    orderBy() {
        let tempData = {
            page: 1,
            order: 'order ASC',
        };
        if (this.state.order == 'order ASC') {
            tempData.order = 'order DESC';
        }
        this.setState(tempData,()=>{
            this.getData()
        })
    }

    readBook(item) {
        this.props.history.push(`/readpage/${this.state.bookId}/${item.content_id}`)
    }

    render() {
        return (
            <div className='directory'>
                <Header />
                <div className='directory_cont'>
                    <div className='directory_cont_header'>
                        <span className='directory_cont_header_l'>共{this.state.totalNum}章</span>
                        <span className={`directory_cont_header_up ${this.state.page == 1 && 'activeColor'}`} onClick={() => this.changePage('last')}>上一页</span>
                        <span className={`directory_cont_header_down ${this.state.page == this.state.totalPage && 'activeColor'}`} onClick={() => this.changePage('next')}>下一页</span>
                        <span className='directory_cont_header_r' onClick={() => this.orderBy()}>{`${this.state.order == 'order ASC' ? '倒序' : '正序'}`}</span>
                    </div>
                    <div className='directory_wrapper'>
                        {!!this.state.data && this.state.data.length > 0 && this.state.data.map((item, index) => (
                            <div key={`dt${index}`} className={`directory_cont_single text-overflow ${item.content_id==this.state.contentId && 'directory_cont_singleActive'} ${item.is_pay_chapter == 1 && item.is_pay == 0 && 'vp_color'}`} onClick={() => this.readBook(item)}>
                                <span>{item.title}</span>
                                {item.is_pay_chapter == 1 && item.is_pay == 0 && <span className='lock'></span>}
                            </div>
                        ))}
                    </div>
                    <div className='directory_cont_header'>
                        <span className={`directory_cont_header_up ${this.state.page == 1 && 'activeColor'}`} onClick={() => this.changePage('last')}>上一页</span>
                        <span className={`directory_cont_header_down ${this.state.page == this.state.totalPage && 'activeColor'}`} onClick={() => this.changePage('next')}>下一页</span>
                    </div>
                </div>
            </div>
        );
    }
}